import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FornecedorPicker from './FornecedorPicker';
import ArpPicker from './ArpPicker';
import DescricaoEntregaPicker from './DescricaoEntregaPicker';
import AcaoGovernamentalPicker from './AcaoGovernamentalPicker';
import FonteRecursoPicker from './FonteRecursoPicker';
import ElementoDespesaPicker from './ElementoDespesaPicker';
import SubelementoDespesaPicker from './SubelementoDespesaPicker';
import * as DescricaoEntregaApi from '../../DescricaoEntregaService';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import DataMaskInput from '../masks/DataMaskInput';
import SaveValidationModal from './SaveValidationModal';

function ArpModal({ show, arp, arpPai: arpPaiProp, onClose, onSave }) {
  const [modo, setModo] = useState('');
  const [arpPaiSelecionado, setArpPaiSelecionado] = useState(null);
  const [arpsParaAditivar, setArpsParaAditivar] = useState([]);
  const [showArpPicker, setShowArpPicker] = useState(false);
  const arpPai = arpPaiProp || arpPaiSelecionado;
  const isAditivo = !!arpPai;
  const criando = !arp && !arpPai;
  const mostrarEscolha = criando && !modo;
  const mostrarSelecaoPai = criando && modo === 'ADITIVO' && !arpPai;
  const [tipoAditivo, setTipoAditivo] = useState('');
  const [itensAditivo, setItensAditivo] = useState([]);
  const [justificativa, setJustificativa] = useState('');
  const [formData, setFormData] = useState({
    numArp: '',
    ano: '',
    idFornecedor: '',
    numProcesso: '',
    dataInicio: '',
    dataFim: '',
    objeto: '',
    descricaoEntrega: '',
    idFonteRecurso: '',
    idAcaoGovernamental: '',
    idElementoDespesa: '',
    idSubelementoDespesa: '',
  });
  const [fornecedores, setFornecedores] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [fontes, setFontes] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [subelementos, setSubelementos] = useState([]);
  const [showFornecedorPicker, setShowFornecedorPicker] = useState(false);
  const [showAcaoPicker, setShowAcaoPicker] = useState(false);
  const [showFontePicker, setShowFontePicker] = useState(false);
  const [showElementoPicker, setShowElementoPicker] = useState(false);
  const [showSubelementoPicker, setShowSubelementoPicker] = useState(false);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSaveValidation, setShowSaveValidation] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [validationWarnings, setValidationWarnings] = useState([]);
  const token = localStorage.getItem('token');
  const ano = localStorage.getItem('anoBase');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const user = JSON.parse(localStorage.getItem('user'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (!show) {
      setModo('');
      setArpPaiSelecionado(null);
      setArpsParaAditivar([]);
      setShowArpPicker(false);
      setTipoAditivo('');
      setItensAditivo([]);
      setJustificativa('');
      return;
    }

    if (!arp && !arpPaiProp) {
      axios
        .get(`${API_BASE_URL.ARP}/entidade/${vinculo.idEntidade}/ano/${ano}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          const lista = Array.isArray(result.data) ? result.data.filter(a => a.tipoCadastro !== 'ADITIVO') : [];
          setArpsParaAditivar(lista);
        })
        .catch(err => {
          console.error('Erro ao carregar ARPs para aditivo:', err);
          setArpsParaAditivar([]);
        });
    }

    if (show) {
      axios
        .get(`${API_BASE_URL.FORNECEDOR}/entidade/${vinculo.idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setFornecedores(result.data))
        .catch(error => console.error('Erro ao carregar fornecedores:', error));

      axios
        .get(`${API_BASE_URL.MODALIDADE}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setModalidades(result.data))
        .catch(error => console.error('Erro ao carregar modalidades:', error));

      axios
        .get(`${API_BASE_URL.ACAO_GOVERNAMENTAL}/entidade/${vinculo.idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setAcoes(result.data))
        .catch(error => console.error('Erro ao carregar ações governamentais:', error));

      axios
        .get(`${API_BASE_URL.FONTE_RECURSO}/entidade/${vinculo.idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setFontes(result.data))
        .catch(error => console.error('Erro ao carregar fontes de recurso:', error));

      axios
        .get(`${API_BASE_URL.ELEMENTO_DESPESA}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setElementos(result.data))
        .catch(error => console.error('Erro ao carregar elementos de despesa:', error));

      axios
        .get(`${API_BASE_URL.SUBELEMENTO_DESPESA}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => setSubelementos(result.data))
        .catch(error => console.error('Erro ao carregar subelementos de despesa:', error));

      const formatDate = date => {
        if (!date) return '';
        if (Array.isArray(date)) {
          const [year, month, day] = date;
          return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        if (typeof date === 'string') return date.split('T')[0];
        return '';
      };

      if (arp) {
        setFormData({
          numArp: arp.numArp || '',
          ano: ano,
          idFornecedor: arp.idFornecedor || '',
          numProcesso: arp.numProcesso || '',
          dataInicio: formatDate(arp.dataInicio),
          dataFim: formatDate(arp.dataFim),
          objeto: arp.objeto || '',
          descricaoEntrega: arp.descricaoEntrega || '',
          idAcaoGovernamental: arp.idAcaoGovernamental || '',
          idFonteRecurso: arp.idFonteRecurso || '',
          idElementoDespesa: arp.idElementoDespesa || '',
          idSubelementoDespesa: arp.idSubelementoDespesa || '',
        });
      } else if (arpPai) {
        setFormData({
          numArp: '',
          ano: arpPai.ano || ano,
          idFornecedor: arpPai.idFornecedor || '',
          numProcesso: arpPai.numProcesso || '',
          dataInicio: formatDate(arpPai.dataInicio),
          dataFim: formatDate(arpPai.dataFim),
          objeto: arpPai.objeto || '',
          descricaoEntrega: arpPai.descricaoEntrega || '',
          idAcaoGovernamental: arpPai.idAcaoGovernamental || '',
          idFonteRecurso: arpPai.idFonteRecurso || '',
          idElementoDespesa: arpPai.idElementoDespesa || '',
          idSubelementoDespesa: arpPai.idSubelementoDespesa || '',
        });
      } else {
        setFormData({
          numArp: '',
          ano: ano,
          idFornecedor: '',
          numProcesso: '',
          dataInicio: '',
          dataFim: '',
          objeto: '',
          descricaoEntrega: '',
          idAcaoGovernamental: '',
          idFonteRecurso: '',
          idElementoDespesa: '',
          idSubelementoDespesa: '',
        });
      }
      // Ao criar novo, se houver apenas uma descrição de entrega para a entidade, aplicá-la automaticamente
      if (!arp && vinculo?.idEntidade) {
        DescricaoEntregaApi.getList(vinculo.idEntidade)
          .then(list => {
            if (Array.isArray(list) && list.length === 1) {
              setFormData(prev => ({ ...prev, descricaoEntrega: list[0].descricao }));
            }
          })
          .catch(err => console.error('Erro ao carregar descrições (auto):', err));
      }
      setValidated(false);
    }
  }, [show, arp, arpPai, token]);


  const handleTipoAditivoChange = (e) => {
    const tipo = e.target.value;
    setTipoAditivo(tipo);
    if (arpPai && tipo) {
      axios
        .get(`${API_BASE_URL.ARP}/proximoNumAditivo/${arpPai.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          setFormData(prev => ({ ...prev, numArp: `${arpPai.numArp} AD${res.data}` }));
        })
        .catch(() => {
          setFormData(prev => ({ ...prev, numArp: `${arpPai.numArp} AD001` }));
        });

      if (tipo === 'QUANTIDADE' || tipo === 'AJUSTE_PRECO' || tipo === 'PRAZO' || tipo === 'VALOR') {
        axios
          .get(`${API_BASE_URL.ARP_ITEM}/arp/${arpPai.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(res => {
            let itensPai = (res.data || []).map(item => ({
              ...item,
              quantidadeOriginal: item.quantidade,
              valorUnitOriginal: item.valorUnit,
            }));
            if (tipo === 'PRAZO') {
              itensPai = itensPai
                .map(item => ({ ...item, quantidade: (item.quantidade || 0) - (item.qtdePedida || 0) }))
                .filter(item => item.quantidade > 0);
            }
            setItensAditivo(itensPai);
          })
          .catch(() => setItensAditivo([]));
      } else {
        setItensAditivo([]);
      }
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleChangeItemAditivo = (index, field, value) => {
    setItensAditivo(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: parseFloat(value) || 0 };
      return updated;
    });
  };

  const [showDescricaoPicker, setShowDescricaoPicker] = useState(false);

  const formatarCodigo = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 17);
    const partes = [
      digits.slice(0, 2),
      digits.slice(2, 5),
      digits.slice(5, 9),
      digits.slice(9, 10),
      digits.slice(10, 13),
      digits.slice(13, 17),
    ];
    return partes.filter(p => p).join('.');
  };

  const handleDescricaoSelect = (descricao) => {
    setFormData(prev => ({ ...prev, descricaoEntrega: descricao }));
    setShowDescricaoPicker(false);
  };

  // Handler para seleção do fornecedor no picker
  const handleFornecedorSelect = (fornecedor) => {
    setFormData(prev => ({ ...prev, idFornecedor: fornecedor.idFornecedor }));
    setShowFornecedorPicker(false);
  };

  const handleAcaoSelect = (acao) => {
    setFormData(prev => ({ ...prev, idAcaoGovernamental: acao.codigo }));
    setShowAcaoPicker(false);
  };

  const handleFonteSelect = (fonte) => {
    setFormData(prev => ({ ...prev, idFonteRecurso: fonte.codigo }));
    setShowFontePicker(false);
  };

  const handleElementoSelect = (elemento) => {
    setFormData(prev => ({ ...prev, idElementoDespesa: elemento.codigo, idSubelementoDespesa: '' }));
    setShowElementoPicker(false);
  };

  const handleSubelementoSelect = (subelemento) => {
    setFormData(prev => ({ ...prev, idSubelementoDespesa: subelemento.codigo }));
    setShowSubelementoPicker(false);
  };

  const validateForm = () => {
    const errors = [];
    const warnings = [];

    if (!formData.objeto) errors.push('Objeto');
    if (!formData.dataInicio) errors.push('Data de Início');
    if (!formData.dataFim) errors.push('Data de Fim');

    if (!formData.idAcaoGovernamental) warnings.push('Ação Governamental');
    if (!formData.idFonteRecurso) warnings.push('Fonte de Recurso');
    if (!formData.idElementoDespesa) warnings.push('Elemento de Despesa');
    if (!formData.idSubelementoDespesa) warnings.push('Subelemento de Despesa');
    if (!formData.numProcesso) warnings.push('Nº do Processo');

    return { errors, warnings };
  };

  const doSave = async () => {
    setLoading(true);
    const anoInt = parseInt(ano, 10);
    const payload = {
      ...formData,
      ano: anoInt,
      idEntidade: vinculo.idEntidade,
      usuario: user?.login || '',
      idElementoDespesa: formData.idElementoDespesa || null,
      idSubelementoDespesa: formData.idSubelementoDespesa || null,
      idFonteRecurso: formData.idFonteRecurso || null,
      idAcaoGovernamental: formData.idAcaoGovernamental || null,
    };

    if (isAditivo && arpPai) {
      payload.tipoCadastro = 'ADITIVO';
      payload.idArpPai = arpPai.id;
      payload.tipoAditivo = tipoAditivo;
      payload.justificativa = justificativa || null;
      if (['QUANTIDADE', 'AJUSTE_PRECO', 'PRAZO', 'VALOR'].includes(tipoAditivo) && itensAditivo.length > 0) {
        payload.itens = itensAditivo.map(item => ({
          id: null,
          idArp: null,
          descricao: item.descricao,
          marca: item.marca,
          unidade: item.unidade,
          quantidade: item.quantidade,
          valorUnit: item.valorUnit,
          bloqueado: false,
        }));
      }
    }

    if (arp?.id) payload.id = arp.id;
    console.log('Payload ARP enviado:', payload);

    try {
      if (arp?.id) {
        await axios.put(`${API_BASE_URL.ARP}/${arp.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
      } else {
        await axios.post(API_BASE_URL.ARP, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
      }
      showDefaultModal('success', arp?.id ? 'ARP atualizada com sucesso!' : (isAditivo ? 'Aditivo ARP cadastrado com sucesso!' : 'ARP cadastrada com sucesso!'));
    } catch (error) {
      console.error('Erro ao salvar ARP:', error);
      const msg = error?.response?.data?.error || 'Erro ao salvar ARP. Verifique os dados e tente novamente.';
      showDefaultModal('error', msg);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (mostrarEscolha || mostrarSelecaoPai) return;
    const anoInt = parseInt(ano, 10);
    if (!formData.numArp || isNaN(anoInt) || !formData.idFornecedor) {
      setValidated(true);
      return;
    }
    if (isAditivo && !tipoAditivo) {
      setValidated(true);
      return;
    }
    if (isAditivo && !justificativa) {
      setValidated(true);
      return;
    }
    const { errors, warnings } = validateForm();
    if (errors.length > 0 || warnings.length > 0) {
      setValidationErrors(errors);
      setValidationWarnings(warnings);
      setShowSaveValidation(true);
      return;
    }
    doSave();
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-journal-text me-2"></i>
                {arp ? (arp.tipoCadastro === 'ADITIVO' ? 'Editar Aditivo ARP' : 'Editar ARP') : (isAditivo ? 'Novo Aditivo ARP' : (modo === 'NOVO' ? 'Nova ARP' : 'Nova ARP ou Aditivo'))}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={loading} title="Fechar"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {mostrarEscolha && (
                <div className="text-center py-5">
                  <h6 className="fw-semibold mb-1">O que deseja cadastrar?</h6>
                  <p className="text-muted small mb-4">Escolha o tipo de cadastro para continuar.</p>
                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <button
                      type="button"
                      className="btn btn-success px-4 py-3"
                      onClick={() => setModo('NOVO')}
                      style={{ minWidth: '220px' }}
                    >
                      <i className="bi bi-file-earmark-plus me-2"></i>
                      Nova ARP
                    </button>
                    <button
                      type="button"
                      className="btn btn-info text-white px-4 py-3"
                      onClick={() => setModo('ADITIVO')}
                      style={{ minWidth: '220px' }}
                    >
                      <i className="bi bi-journal-plus me-2"></i>
                      Aditivo
                    </button>
                  </div>
                </div>
              )}

              {mostrarSelecaoPai && (
                <div className="py-4">
                  <h6 className="fw-semibold mb-1">Aditivo de ARP</h6>
                  <p className="text-muted small mb-3">
                    Selecione a ARP a ser aditivada. O formulário só será liberado após a escolha.
                  </p>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">
                      ARP a aditivar <span className="text-danger">*</span>
                    </label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        value={arpPaiSelecionado
                          ? `${arpPaiSelecionado.numArp} - ${arpPaiSelecionado.fornecedor?.nome || arpPaiSelecionado.nomeFornecedor || ''}`
                          : ''}
                        placeholder="Clique para buscar a ARP..."
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowArpPicker(true)}
                        title="Buscar ARP"
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {arpPaiSelecionado && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setArpPaiSelecionado(null)}
                          title="Limpar seleção"
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                    {arpsParaAditivar.length === 0 && (
                      <small className="text-muted d-block mt-1">
                        Nenhuma ARP disponível para aditivo no ano selecionado.
                      </small>
                    )}
                  </div>
                  <ArpPicker
                    show={showArpPicker}
                    arps={arpsParaAditivar}
                    onSelect={a => {
                      setArpPaiSelecionado(a);
                      setShowArpPicker(false);
                    }}
                    onClose={() => setShowArpPicker(false)}
                  />
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => setModo('')}
                    >
                      <i className="bi bi-arrow-left me-1"></i>
                      Voltar
                    </button>
                  </div>
                </div>
              )}

              {!mostrarEscolha && !mostrarSelecaoPai && (
              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Número da ARP <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${validated && !formData.numArp ? 'is-invalid' : ''}`}
                        name="numArp"
                        value={formData.numArp}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Ex: 001/2024"
                        disabled={loading || isAditivo}
                      />
                      {validated && !formData.numArp && (
                        <div className="invalid-feedback">Por favor, informe o número da ARP.</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Fornecedor <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className={`form-control ${validated && !formData.idFornecedor ? 'is-invalid' : ''}`}
                          value={
                            fornecedores.find(f => f.idFornecedor === formData.idFornecedor)
                              ? `${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).nome} - ${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).cpfOrCnpj}`
                              : ''
                          }
                          placeholder="Clique para buscar o fornecedor..."
                          readOnly
                          disabled={loading}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowFornecedorPicker(true)}
                          disabled={loading}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idFornecedor && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => setFormData(prev => ({ ...prev, idFornecedor: '' }))}
                            disabled={loading}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>
                      {validated && !formData.idFornecedor && (
                        <div className="invalid-feedback">Por favor, selecione o fornecedor.</div>
                      )}
                      <FornecedorPicker
                        show={showFornecedorPicker}
                        fornecedores={fornecedores}
                        selectedId={formData.idFornecedor}
                        onSelect={handleFornecedorSelect}
                        onClose={() => setShowFornecedorPicker(false)}
                      />
                    </div>
                  </div>
                </div>

                {isAditivo && (
                  <>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label small fw-semibold">
                            Tipo de Aditivo <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control form-control-sm"
                            name="tipoAditivo"
                            value={tipoAditivo}
                            onChange={handleTipoAditivoChange}
                            disabled={loading || !!arp}
                            required={isAditivo}
                          >
                            <option value="">Selecione...</option>
                            <option value="PRAZO">Prazo (Art. 107)</option>
                            <option value="VALOR">Vigência e Valor (Art. 124, I, "a")</option>
                            <option value="AJUSTE_PRECO">Ajuste de Preço (Art. 124, II, "d")</option>
                            <option value="QUANTIDADE">Quantidade (Art. 124, I, "b")</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label className="form-label small fw-semibold">ARP Pai</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={`${arpPai?.numArp || ''} - ${arpPai?.fornecedor?.nome || ''}`}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Justificativa <span className="text-danger">*</span>
                        <small className="text-muted ms-1">(Art. 124, Lei 14.133/2021)</small>
                      </label>
                      <textarea
                        className="form-control form-control-sm"
                        rows={3}
                        value={justificativa}
                        onChange={(e) => setJustificativa(e.target.value)}
                        placeholder="Descreva a justificativa para o aditivo conforme Art. 124 da Lei 14.133/2021..."
                        disabled={loading}
                      />
                    </div>

                    {(tipoAditivo && ['QUANTIDADE', 'AJUSTE_PRECO', 'PRAZO', 'VALOR'].includes(tipoAditivo) && itensAditivo.length > 0) && (
                      <div className="mb-3">
                        <label className="form-label small fw-semibold">
                          Itens do Aditivo
                          {tipoAditivo === 'QUANTIDADE' && (
                            <small className="text-muted ms-1">(Art. 125 - acréscimo/supressão de até 25%)</small>
                          )}
                          {tipoAditivo === 'VALOR' && (
                            <small className="text-muted ms-1">(edita valores e vigência - acréscimo/supressão de valores de até 25%)</small>
                          )}
                          {tipoAditivo === 'AJUSTE_PRECO' && (
                            <small className="text-muted ms-1">(Art. 130 - restabelecimento do equilíbrio)</small>
                          )}
                          {tipoAditivo === 'PRAZO' && (
                            <small className="text-muted ms-1">(somente leitura - apenas prazo alterado)</small>
                          )}
                        </label>
                        <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          <table className="table table-sm table-bordered mb-0">
                            <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                              <tr>
                                <th style={{ width: '5%' }}>#</th>
                                <th>Descrição</th>
                                <th>Unidade</th>
                                <th style={{ width: '12%' }}>Qtde</th>
                                <th style={{ width: '15%' }}>V. Unit</th>
                                <th style={{ width: '15%' }}>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {itensAditivo.map((item, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td className="small">{item.descricao}</td>
                                  <td>{item.unidade}</td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={item.quantidade}
                                      onChange={(e) => handleChangeItemAditivo(idx, 'quantidade', e.target.value)}
                                      min={0}
                                      step="0.01"
                                      disabled={loading || tipoAditivo === 'AJUSTE_PRECO' || tipoAditivo === 'PRAZO' || tipoAditivo === 'VALOR'}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={item.valorUnit}
                                      onChange={(e) => handleChangeItemAditivo(idx, 'valorUnit', e.target.value)}
                                      min={0}
                                      step="0.01"
                                      disabled={loading || tipoAditivo === 'QUANTIDADE' || tipoAditivo === 'PRAZO'}
                                    />
                                  </td>
                                  <td className="small fw-semibold">
                                    {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
                                      (item.quantidade || 0) * (item.valorUnit || 0)
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Descrição de Entrega movida para abaixo do campo Objeto */}


                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Nº Processo</label>
                      <input
                        type="text"
                        className="form-control"
                        name="numProcesso"
                        value={formData.numProcesso}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Ex: 001/2024"
                        disabled={loading || isAditivo}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Data Início</label>
                      <DataMaskInput name="dataInicio" value={formData.dataInicio} onChange={handleChange} disabled={loading || isAditivo} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Data Fim</label>
                      <DataMaskInput
                        name="dataFim"
                        value={formData.dataFim}
                        onChange={handleChange}
                        disabled={loading || (isAditivo && tipoAditivo && tipoAditivo !== 'PRAZO' && tipoAditivo !== 'VALOR')}
                      />
                      {(isAditivo && tipoAditivo === 'PRAZO') && (
                        <small className="text-info">Nova data de vigência (Art. 107)</small>
                      )}
                      {(isAditivo && tipoAditivo === 'VALOR') && (
                        <small className="text-info">Data de fim opcional - permite prazo e valor juntos</small>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">Objeto</label>
                  <textarea
                    className="form-control"
                    rows={2}
                    name="objeto"
                    value={formData.objeto}
                    onChange={handleChange}
                    placeholder="Descreva o objeto da ARP..."
                    disabled={loading || isAditivo}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Fonte de Recurso</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            fontes.find(f => f.codigo === formData.idFonteRecurso)
                              ? `${fontes.find(f => f.codigo === formData.idFonteRecurso).codigo} - ${fontes.find(f => f.codigo === formData.idFonteRecurso).descricao}`
                              : ''
                          }
                          placeholder="Clique para buscar a fonte..."
                          readOnly
                          disabled={loading || isAditivo}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowFontePicker(true)}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idFonteRecurso && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => setFormData(prev => ({ ...prev, idFonteRecurso: '' }))}
                            disabled={loading || isAditivo}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Ação Governamental</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            acoes.find(a => a.codigo === formData.idAcaoGovernamental)
                              ? `${formatarCodigo(acoes.find(a => a.codigo === formData.idAcaoGovernamental).codigo)} - ${acoes.find(a => a.codigo === formData.idAcaoGovernamental).descricao}`
                              : ''
                          }
                          placeholder="Clique para buscar a ação..."
                          readOnly
                          disabled={loading || isAditivo}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowAcaoPicker(true)}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idAcaoGovernamental && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => setFormData(prev => ({ ...prev, idAcaoGovernamental: '' }))}
                            disabled={loading || isAditivo}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Elemento de Despesa</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            elementos.find(e => e.codigo === formData.idElementoDespesa)
                              ? `${elementos.find(e => e.codigo === formData.idElementoDespesa).codigo} - ${elementos.find(e => e.codigo === formData.idElementoDespesa).descricao}`
                              : ''
                          }
                          placeholder="Clique para buscar o elemento..."
                          readOnly
                          disabled={loading || isAditivo}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowElementoPicker(true)}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idElementoDespesa && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => setFormData(prev => ({ ...prev, idElementoDespesa: '', idSubelementoDespesa: '' }))}
                            disabled={loading || isAditivo}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Subelemento de Despesa</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa)
                              ? `${subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa).codigo} - ${subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa).descricao}`
                              : ''
                          }
                          placeholder="Clique para buscar o subelemento..."
                          readOnly
                          disabled={loading || isAditivo || !formData.idElementoDespesa}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowSubelementoPicker(true)}
                          disabled={loading || isAditivo || !formData.idElementoDespesa}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idSubelementoDespesa && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => setFormData(prev => ({ ...prev, idSubelementoDespesa: '' }))}
                            disabled={loading || isAditivo}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">Descrição de Entrega</label>
                  <div className="d-flex">
                    <textarea
                      className="form-control flex-grow-1"
                      name="descricaoEntrega"
                      value={formData.descricaoEntrega}
                      onChange={handleChange}
                      rows={3}
                      disabled={isAditivo}
                    />
                    <div className="d-flex flex-column ms-2">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm mb-2"
                        style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                        onClick={() => setShowDescricaoPicker(true)}
                        disabled={isAditivo}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.descricaoEntrega && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                          onClick={() => setFormData(prev => ({ ...prev, descricaoEntrega: '' }))}
                          disabled={isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              )}
            </div>
            <div className="modal-footer">
              {showDescricaoPicker && (
                <DescricaoEntregaPicker show={showDescricaoPicker} onClose={() => setShowDescricaoPicker(false)} onSelect={handleDescricaoSelect} />
              )}
              {showAcaoPicker && (
                <AcaoGovernamentalPicker
                  show={showAcaoPicker}
                  acoes={acoes}
                  selectedCodigo={formData.idAcaoGovernamental}
                  onSelect={handleAcaoSelect}
                  onClose={() => setShowAcaoPicker(false)}
                />
              )}
              {showFontePicker && (
                <FonteRecursoPicker
                  show={showFontePicker}
                  fontes={fontes}
                  selectedCodigo={formData.idFonteRecurso}
                  onSelect={handleFonteSelect}
                  onClose={() => setShowFontePicker(false)}
                />
              )}
              {showElementoPicker && (
                <ElementoDespesaPicker
                  show={showElementoPicker}
                  elementos={elementos}
                  selectedCodigo={formData.idElementoDespesa}
                  onSelect={handleElementoSelect}
                  onClose={() => setShowElementoPicker(false)}
                />
              )}
              {showSubelementoPicker && (
                <SubelementoDespesaPicker
                  show={showSubelementoPicker}
                  subelementos={subelementos.filter(s => s.idElemento === formData.idElementoDespesa)}
                  selectedCodigo={formData.idSubelementoDespesa}
                  onSelect={handleSubelementoSelect}
                  onClose={() => setShowSubelementoPicker(false)}
                />
              )}
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} disabled={loading}>
                <i className="bi bi-x-circle me-1"></i>Cancelar
              </button>
              {!mostrarEscolha && !mostrarSelecaoPai && (
                <button type="submit" className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={loading}>
                  {loading ? (
                    <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
                  ) : (
                    <><i className="bi bi-check-circle me-1"></i>Salvar</>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
      <SaveValidationModal
        show={showSaveValidation}
        errors={validationErrors}
        warnings={validationWarnings}
        onClose={() => { setShowSaveValidation(false); setValidationErrors([]); setValidationWarnings([]); }}
        onConfirm={() => { setShowSaveValidation(false); setValidationErrors([]); setValidationWarnings([]); doSave(); }}
      />
    </>
  );
}

export default ArpModal;
